var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"illustrate",staticClass:"bg-white"},[_c('Claims',{attrs:{"claims":_vm.illustInfo,"qybFlag":_vm.qybFlag,"claimsShow":_vm.claimsShow}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }